import ListFeaturePage from '@/common/components/list-route/ListFeaturePage.tsx';
import { getColumns } from '@/features/data/clients/columns.tsx';
import { ClientFilterBarMain } from '@/features/data/clients/components/ClientFilterBarMain.tsx';
import ClientPagination from '@/features/data/clients/components/ClientPagination.tsx';
import useClientQueryFromAtom from '@/features/data/clients/hooks/useClientQueryFromAtom.tsx';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/data/clients')({
  component: RouteComponent,
});

function RouteComponent() {
  const clientsQuery = useClientQueryFromAtom();
  const columns = useMemo(() => getColumns(), []);

  return (
    <ListFeaturePage
      analyticsSurface="clients"
      storageKey="filter-aside:clients"
      query={clientsQuery}
      columns={columns}
      FilterBar={ClientFilterBarMain}
      Pagination={ClientPagination}
    />
  );
}
